// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GenerateTakeoffModalDocumentsQueryVariables = Types.Exact<{
  filter: Types.DocumentsFilter;
  page: Types.PageFilter;
}>;


export type GenerateTakeoffModalDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentsPageResult', entities: Array<{ __typename?: 'Document', id: string, name: string, asset: { __typename?: 'Asset', id: string } }> } };


export const GenerateTakeoffModalDocumentsDocument = gql`
    query GenerateTakeoffModalDocuments($filter: DocumentsFilter!, $page: PageFilter!) {
  documents: documentsPage(filter: $filter, page: $page) {
    entities {
      id
      name
      asset {
        id
      }
    }
  }
}
    `;

/**
 * __useGenerateTakeoffModalDocumentsQuery__
 *
 * To run a query within a React component, call `useGenerateTakeoffModalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTakeoffModalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTakeoffModalDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGenerateTakeoffModalDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables> & ({ variables: GenerateTakeoffModalDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>(GenerateTakeoffModalDocumentsDocument, options);
      }
export function useGenerateTakeoffModalDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>(GenerateTakeoffModalDocumentsDocument, options);
        }
// @ts-ignore
export function useGenerateTakeoffModalDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>;
export function useGenerateTakeoffModalDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GenerateTakeoffModalDocumentsQuery | undefined, GenerateTakeoffModalDocumentsQueryVariables>;
export function useGenerateTakeoffModalDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>(GenerateTakeoffModalDocumentsDocument, options);
        }
export type GenerateTakeoffModalDocumentsQueryHookResult = ReturnType<typeof useGenerateTakeoffModalDocumentsQuery>;
export type GenerateTakeoffModalDocumentsLazyQueryHookResult = ReturnType<typeof useGenerateTakeoffModalDocumentsLazyQuery>;
export type GenerateTakeoffModalDocumentsSuspenseQueryHookResult = ReturnType<typeof useGenerateTakeoffModalDocumentsSuspenseQuery>;
export type GenerateTakeoffModalDocumentsQueryResult = ApolloReactCommon.QueryResult<GenerateTakeoffModalDocumentsQuery, GenerateTakeoffModalDocumentsQueryVariables>;